/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Required_Free_TextInputs */



/**
* | output |
* | --- |
* | "This feature isn't included in the Free plan. Upgrade to Starter or Pro to use it." |
*
* @param {Upgrade_Required_Free_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const upgrade_required_free_text = /** @type {((inputs?: Upgrade_Required_Free_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Required_Free_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette fonctionnalité n'est pas incluse dans l'offre Gratuite. Passez à Starter ou Pro pour l'utiliser.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Funktion ist im Free-Tarif nicht enthalten. Wechseln Sie zu Starter oder Pro, um sie zu nutzen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questa funzione non è inclusa nel piano Gratuito. Passa a Starter o Pro per usarla.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Эта функция не входит в тариф Free. Перейдите на Starter или Pro, чтобы ею воспользоваться.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esta función no está incluida en el plan Gratis. Pasa a Starter o Pro para usarla.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("免费套餐不包含此功能。升级到 Starter 或 Pro 即可使用。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("この機能は Free プランに含まれていません。Starter または Pro にアップグレードするとご利用いただけます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह सुविधा Free प्लान में शामिल नहीं है। इसका इस्तेमाल करने के लिए Starter या Pro पर अपग्रेड करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esta funcionalidade não está incluída no plano Gratuito. Mude para Starter ou Pro para a utilizar.")
	return /** @type {LocalizedString} */ ("This feature isn't included in the Free plan. Upgrade to Starter or Pro to use it.")
});